<template>
    <div class="confirm-tooltip__container" :class="{'confirm-tooltip--active': this.active}">
        <div class="confirm-tooltip__button btn-settings-action" :class="this.buttonBranding" :ref="this.confirmAction" @click="toggle">
            <font-awesome-icon :class="{'mr-1': this.buttonText }" v-if="this.buttonIcon" :icon="this.btnIcon"></font-awesome-icon>
            <span v-if="this.buttonText">{{buttonText}}</span>
            <span v-if="this.buttonSecondaryText" class="btn-secondary-text">{{buttonSecondaryText}}</span>
        </div>
        <span class="confirm-tooltip__action-sticky" v-show="active" ref="action-sticky">
            <div class="confirm-tooltip__text-container" :class="{'confirm-tooltip__text-container--pb-0': this.hasFields}">
                <slot></slot>
            </div>
            <div class="confirm-tooltip__actions">
                <button v-if="this.isButton" class="confirm-tooltip__btn" :class="this.confirmActionBranding" alt="Delete" type="submit" value="submit" @click="confirm">
                    <font-awesome-icon icon="check" class="text-success"></font-awesome-icon>
                </button>
                <span v-else class="confirm-tooltip__btn" :class="this.confirmActionBranding" alt="Delete" @click="confirm">
                    <font-awesome-icon icon="check" class="text-success"></font-awesome-icon>
                </span>
                <span class="confirm-tooltip__btn" :class="this.cancelActionBranding" alt="Do Not Delete" @click="cancel">
                    <font-awesome-icon icon="times" class="text-danger"></font-awesome-icon>
                </span>
            </div>
        </span>
    </div>
</template>

<script>
    import { isMobile } from '../isMobileChecker';
    import Vue from 'vue';
    import VueResource from 'vue-resource';
    Vue.use(VueResource);
    export default {
        props: {
            buttonIcon: {
                type: String,
            },
            buttonText: {
                type: String,
            },
            buttonSecondaryText: {
                type: String,
            },
            buttonBranding: {
                default: 'btn-success-hover',
                type: String,
            },
            /* Make sure you setup an event for the actions in events.js */
            confirmAction: {
                type: String,
            },
            cancelAction: {
                type: String,
            },
            confirmActionBranding: {
                default: 'btn-success-hover btn-svg-white-hover',
                type: String,
            },
            cancelActionBranding: {
                default: 'btn-danger-hover btn-svg-white-hover',
                type: String,
            },
            isButton: {
                default: true,
                type: Boolean,
            },
            hasFields: {
                default: false,
                type: Boolean,
            },
            inlinePositioning: {
                default: false,
                type: Boolean,
            },
            blurElements: {
                type: String,
            },
            stickyTopOffsetAmount: {
                default: 50,
                type: Number,
            }
        },
        data: function () {
            return {
                response: false,
                btnIcon: this.buttonIcon,
                btnText: this.buttonText,
                btnSecondaryText: this.buttonSecondaryText,
                btnBranding: this.buttonBranding,
                cancelBranding: this.cancelActionBranding,
                confirmBranding: this.confirmActionBranding,
                text: this.confirmText,
                active: false,
                isMobile: false,
                stickyTopOffset: this.stickyTopOffsetAmount,
                positionInline: this.inlinePositioning,
                // Items that get blurred when the tooltip is open.
                blurredElementSelectors: this.blurElements,
                blurredElements: [],
            }
        },
        mounted () {
            this.setup();
        },
        methods: {
            toggle: function() {
              if (this.active === false) {
                  this.active = true;
                  // Position the tooltip.
                  if (this.positionInline) {
                      this.inlinePositionTooltip();
                  } else {
                      this.autoPositionTooltip();
                  }
              } else {
                  this.active = false;
              }
              // Blur/Unblur things.
              if (this.blurredElements) {
                  this.toggleBlur();
              }
            },
            confirm: function() {
                if (this.confirmAction) {
                    this.$root.$emit(this.confirmAction);
                }
                this.toggle();
            },
            cancel: function() {
                if (this.cancelAction) {
                    this.$root.$emit(this.cancelAction);
                }
                this.toggle();
            },
            autoPositionTooltip: function() {

                // Pages with Auto position.
                let position = this.$refs[this.confirmAction].getBoundingClientRect();
                if (this.isMobile) {
                    this.$refs['action-sticky'].classList.add('confirm-tooltip__action-sticky--wide');
                    this.$refs['action-sticky'].style.left = `0px`;
                    this.$refs['action-sticky'].style.top = `${position.top + window.pageYOffset + this.stickyTopOffset}px`;
                }
                else {
                    this.$refs['action-sticky'].style.left = `${position.left}px`;
                    this.$refs['action-sticky'].style.top = `${position.top + window.pageYOffset + this.stickyTopOffset}px`;
                }

            },
            inlinePositionTooltip: function() {
                // Pages with AutoPositioning disabled for the tooltip.
                if (this.positionInline && !this.isMobile) {
                    this.$refs['action-sticky'].style.top = `${this.stickyTopOffset}px`;
                }
                else if (this.positionInline && this.isMobile) {
                    this.$refs['action-sticky'].classList.add('confirm-tooltip__action-sticky--wide');
                    this.$refs['action-sticky'].style.left = `0px`;
                    this.$refs['action-sticky'].style.top = `${this.stickyTopOffset}px`;
                }
            },
            toggleBlur: function() {
                this.blurredElements.forEach((el)=>{
                    if (!el.classList.contains('blur--low')) {
                        el.classList.add('blur--low');
                    } else {
                        el.classList.remove('blur--low');
                    }
                });
            },
            setup: function() {
                this.isMobile = isMobile();

                // Cache the elements we will blur when toggled.
                if (this.blurredElementSelectors) {
                    const elementsToBlur = this.blurredElementSelectors.split(",");
                    elementsToBlur.forEach((el, index) => {
                        this.blurredElements[index] = document.querySelector(`.${el}`);
                    });
                }
            }

        }
    }
</script>
